var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WeInput',{staticClass:"mb-0",attrs:{"input":_vm.value,"id":_vm.componentId + '-value',"small-size":_vm.size == 'sm',"filter-number":_vm.filterNumber},on:{"input":_vm.setInputValue}})}
var staticRenderFns = []

export { render, staticRenderFns }